import React from "react";
import Confetti from "react-confetti";

function ConfettiComponent() {
  const { innerWidth: width, innerHeight: height } = window;
  return <Confetti width={width} height={height} />;
}

export default ConfettiComponent;
